import { defineComponent as _defineComponent } from 'vue'
import TChip from '~/components/atoms/t-chip.vue';
import { Sort } from '~/types/sort';


export default /*#__PURE__*/_defineComponent({
  __name: 'SortButtons',
  props: {
    sort: null
  },
  emits: ["update:sort"],
  setup(__props: any) {




return { __sfc: true,TChip }
}

})